import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    { Header: "เลขบัตรประชาชน", accessor: "idcard", showInFilter: false },
    { Header: "ชื่อ-สกุล", accessor: "customer_name", showInFilter: false },
    {
      Header: "เบอร์โทร",
      accessor: "customer_phonenumber",
      showInFilter: false,
    },
    {
      Header: "ชื่อร้าน/บริษัท",
      accessor: "company_name",
      showInFilter: false,
    },

    {
      Header: "Actions",
      accessor: "actions",
      disableSortBy: true,
      // Width: "10%",
      Cell: ({ row }) => {
        const orderStatus = row.order_status; // Use optional chaining

        return (
          <div>
            <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && activeRowId === row.id}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => {
                  setViewProduct(row);
                  handleViewOpen();
                  handleMenuClose();
                }}
              >
                <RemoveRedEyeIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  ดูรายละเอียด
                </span>
              </MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];
  return columns;
};

export default useColumns;
